import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-form" }
const _hoisted_2 = {
  slot: "label",
  class: "address-autocomplete__label",
  for: "address-combobox"
}
const _hoisted_3 = { class: "order-form order-form-3-cols" }
const _hoisted_4 = {
  slot: "label",
  for: "zipcode"
}
const _hoisted_5 = { class: "zipcode-wrapper" }
const _hoisted_6 = ["placeholder", "aria-invalid", "readonly"]
const _hoisted_7 = {
  slot: "label",
  for: "housenumber"
}
const _hoisted_8 = ["placeholder", "aria-invalid", "readonly"]
const _hoisted_9 = {
  slot: "label",
  for: "extension"
}
const _hoisted_10 = ["placeholder", "readonly"]
const _hoisted_11 = { class: "order-form order-form-2-cols" }
const _hoisted_12 = {
  slot: "label",
  for: "street"
}
const _hoisted_13 = ["placeholder", "aria-invalid", "readonly"]
const _hoisted_14 = {
  slot: "label",
  for: "city"
}
const _hoisted_15 = ["placeholder", "aria-invalid", "readonly"]
const _hoisted_16 = { class: "order-form order-form-2-cols" }
const _hoisted_17 = {
  slot: "label",
  for: "province"
}
const _hoisted_18 = ["placeholder", "aria-invalid", "readonly"]
const _hoisted_19 = {
  slot: "label",
  for: "country"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass(["address-form", { ungapped: !$setup.isManual }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("y-input-wrapper", null, [
        _createElementVNode("label", _hoisted_2, [
          _createTextVNode(_toDisplayString($props.label) + " ", 1 /* TEXT */),
          _createVNode($setup["ManualButton"], {
            onClick: _cache[0] || (_cache[0] = () => ($setup.isManual = !$setup.isManual))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.labels.searchManual), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createVNode($setup["AddressInput"], {
          placeholder: $props.placeholder,
          "is-form-submitted": $props.isFormSubmitted,
          disabled: $setup.isManual,
          "no-results-message": $props.labels.noResults,
          "reset-label": $props.labels.reset,
          "search-error-message": $props.labels.searchError,
          onAddressSelected: _cache[1] || (_cache[1] = (details) => ($setup.modelValue = details))
        }, null, 8 /* PROPS */, ["placeholder", "is-form-submitted", "disabled", "no-results-message", "reset-label", "search-error-message"])
      ])
    ]),
    _createVNode($setup["CollapsibleRoot"], { open: $setup.isManual }, {
      default: _withCtx(() => [
        _createVNode($setup["CollapsibleContent"], { class: "address-form" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("y-input-wrapper", null, [
                _createElementVNode("label", _hoisted_4, _toDisplayString($props.labels.zipcode), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    class: "order-form__input-text",
                    id: "zipcode",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.manualSelection.postcode) = $event)),
                    placeholder: $props.placeholders.zipcode,
                    "aria-invalid": $props.isFormSubmitted && $setup.isManual && !$setup.manualSelection.postcode,
                    readonly: !$setup.isManual,
                    onBlur: _withModifiers($setup.checkZipcodeValidity, ["prevent"])
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6), [
                    [_vModelText, $setup.manualSelection.postcode]
                  ]),
                  ($setup.isZipcodeValid === false)
                    ? (_openBlock(), _createBlock($setup["BadgeX"], {
                        key: 0,
                        class: "zipcode-validation-icon zipcode-validation-icon--invalid"
                      }))
                    : _createCommentVNode("v-if", true),
                  ($setup.isZipcodeValid)
                    ? (_openBlock(), _createBlock($setup["BadgeCheck"], {
                        key: 1,
                        class: "zipcode-validation-icon zipcode-validation-icon--valid"
                      }))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("y-input-wrapper", null, [
                _createElementVNode("label", _hoisted_7, _toDisplayString($props.labels.house_number), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  class: "order-form__input-text",
                  id: "housenumber",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.manualSelection.house_number) = $event)),
                  placeholder: $props.placeholders.house_number,
                  "aria-invalid": $props.isFormSubmitted && $setup.isManual && !$setup.manualSelection.house_number,
                  readonly: !$setup.isManual,
                  onBlur: _withModifiers($setup.checkAddressPrefill, ["prevent"])
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_8), [
                  [_vModelText, $setup.manualSelection.house_number]
                ])
              ]),
              _createElementVNode("y-input-wrapper", null, [
                _createElementVNode("label", _hoisted_9, _toDisplayString($props.labels.extension), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  class: "order-form__input-text",
                  id: "extension",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.manualSelection.extension) = $event)),
                  placeholder: $props.placeholders.extension,
                  readonly: !$setup.isManual,
                  onBlur: _withModifiers($setup.checkAddressPrefill, ["prevent"])
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_10), [
                  [_vModelText, $setup.manualSelection.extension]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("y-input-wrapper", null, [
                _createElementVNode("label", _hoisted_12, _toDisplayString($props.labels.street), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  class: "order-form__input-text",
                  id: "street",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.manualSelection.street) = $event)),
                  placeholder: $props.placeholders.street,
                  "aria-invalid": $props.isFormSubmitted && $setup.isManual && !$setup.manualSelection.street,
                  readonly: !$setup.isManual
                }, null, 8 /* PROPS */, _hoisted_13), [
                  [_vModelText, $setup.manualSelection.street]
                ])
              ]),
              _createElementVNode("y-input-wrapper", null, [
                _createElementVNode("label", _hoisted_14, _toDisplayString($props.labels.city), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  class: "order-form__input-text",
                  id: "city",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.manualSelection.city) = $event)),
                  placeholder: $props.placeholders.city,
                  "aria-invalid": $props.isFormSubmitted && $setup.isManual && !$setup.manualSelection.city,
                  readonly: !$setup.isManual
                }, null, 8 /* PROPS */, _hoisted_15), [
                  [_vModelText, $setup.manualSelection.city]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("y-input-wrapper", null, [
                _createElementVNode("label", _hoisted_17, _toDisplayString($props.labels.state), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  class: "order-form__input-text",
                  id: "province",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.manualSelection.province) = $event)),
                  placeholder: $props.placeholders.state,
                  "aria-invalid": $props.isFormSubmitted && $setup.isManual && !$setup.manualSelection.province,
                  readonly: !$setup.isManual
                }, null, 8 /* PROPS */, _hoisted_18), [
                  [_vModelText, $setup.manualSelection.province]
                ])
              ]),
              _createElementVNode("y-input-wrapper", null, [
                _createElementVNode("label", _hoisted_19, _toDisplayString($props.labels.country), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  class: "order-form__input-text",
                  id: "country",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.manualSelection.country) = $event)),
                  readonly: ""
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.manualSelection.country]
                ])
              ])
            ])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"])
  ], 2 /* CLASS */))
}